import {
    signInWithEmailAndPassword,
    sendEmailVerification
//    onAuthStateChanged,
//    getIdToken,
} from 'firebase/auth'
import {auth} from '@/firebase.config'
import { establishSsoSession, sharedSignOut } from '@/domain/sharedSso'
import {clearUserCache, createUser, createGoogleProfile, updateUserTimezone} from "@/api";

function getBrowserTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}

export const authStore = {
    namespaced: true,
    state: {
        user: null,
    },
    getters: {
        user(state) {
            return state.user
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
            localStorage.setItem('authenticated', true);

            localStorage.setItem('authUser', JSON.stringify(user));

        },
        clearUser(state) {
            state.user = null
            localStorage.removeItem('authenticated');
            localStorage.removeItem('authUser');
            localStorage.removeItem('code');
            localStorage.removeItem('role');
        },
    },
    actions: {
        async register(context, data) {
            const response = await createUser(data)
            if (response.success) {
                // TODO email verification
                const credential = await signInWithEmailAndPassword(auth, data.email, data.password);
                await establishSsoSession(auth).catch(() => {});
                context.commit('setUser', credential.user)
                localStorage.setItem("tz", data.timezone || getBrowserTimezone());
                sendEmailVerification(credential.user)
                    .then(() => {
                        console.log('Email verification sent!');
                    });
            } else {
               throw new Error('Error: Please create your account again.')
            }
        },

        async logIn(context, submission) {
            const response = await signInWithEmailAndPassword(auth, submission.email, submission.password)
            if (response) {
                await establishSsoSession(auth).catch(() => { /* SSO may not be deployed yet. */ });
                context.commit('setUser', response.user)
                const tz = getBrowserTimezone();
                const cached = localStorage.getItem("tz");
                if (tz !== cached) {
                    localStorage.setItem("tz", tz);

                    // 서버에서 user 식별 필요. 보통 firebase uid 씀.
                    updateUserTimezone(tz).catch((error) => {
                        console.error(error);
                    });
                }
            } else {
                throw new Error('login failed')
            }
        },

        async logOut(context) {
            await sharedSignOut(auth)
            clearUserCache();
            context.commit('clearUser')
        },

        async fetchUser(context, user) {
            if (user) {
                context.commit("setUser", {
                    displayName: user.displayName,
                    email: user.email
                });
            } else {
                context.commit("clearUser");
            }
        },
        async authSignIn(context, user) {
            await establishSsoSession(auth).catch(() => { /* Preserve existing local sign-in. */ });
            context.commit('setUser', user);
        },

        // Completes profile creation for a Google-authenticated user who has
        // no `users` DB row yet. Cannot reuse `register`, which always goes
        // through the unauthenticated password-based createUser() flow —
        // the Firebase Auth account here already exists (created by the
        // Google popup), so there's no account to mint and no password.
        async completeGoogleProfile(context, data) {
            try {
                const response = await createGoogleProfile(data);
                localStorage.setItem("tz", data.timezone || getBrowserTimezone());
                return response;
            } catch (error) {
                if (error.response?.status === 409) {
                    // Idempotent: this uid's profile already exists (double
                    // submit, or a returning Google user who already
                    // onboarded) — not a failure the user needs to see.
                    localStorage.setItem("tz", data.timezone || getBrowserTimezone());
                    return error.response.data;
                }
                throw new Error(error.response?.data?.message || 'Error: Please try creating your profile again.');
            }
        },

    }
}
